import { mapState } from "vuex";
import order_seller from "@/views/order/orderDialog/orderSeller";
import contract_sign from "@/views/order/orderDialog/contractSign.vue";
import ShippingOptions from "@/views/order/orderDialog/shippingOptions/shippingOptions.vue";
import tabPane from "./components/tab-pane/index.vue";
import requestApi from "@/utils/requestApi";

export default {
  components: {
    tabPane,
    order_seller,
    contract_sign,
    ShippingOptions,
  },
  data() {
    return {
      loading: false,
      orderStatusTab: {},
      searchForm: {
        confirmStatus: "",
        orderTimeStart: "",
        orderTimeEnd: "",
        orderId: "",
        delivery: "",
        orderVehicleStatus: "",
        orderType: "",
        goodsName: "",
        nextSingleName: "",
        receiverName: "",
        pageSize: 10,
        pageNum: 1,
        platformType: "SC",
        orderStatus: "0",
        orderTimeInterval: [],
      },
      list: [],
      totalNum: 0,
      pageNum: 0,
      order: {},
      orderGoodsList: [],
    };
  },
  computed: mapState({
    userInfo: (state) => state.app.userInfo,
  }),
  created() {
    if (this.$route.query.confirmStatus) {
      this.searchForm.confirmStatus = Number(this.$route.query.confirmStatus);
    }
    console.log("this.searchForm==========", this.searchForm.confirmStatus);
    this.selOrderMjStatusByParam();
    this.searchForm.pageNum = 1;
    this.selMjOrderListByParam();
  },
  mounted() {
    const body = document.querySelector("body");
    body.classList.add("seller-style");
  },
  methods: {
    handleTabsClick() {
      this.searchForm.pageNum = 1;
      this.selMjOrderListByParam();
    },
    handleClick() {
      this.selMjOrderListByParam();
    },
    selOrderMjStatusByParam() {
      this.$store.dispatch("orderTo/index/selOrderMjStatusByParam", { platformType: "SC", isSeller: 1 }).then((res) => {
        this.orderStatusTab = res.data;
      });
    },
    selMjOrderListByParam() {
      this.loading = true;
      console.log("this.searchForm.orderTimeInterval", this.searchForm.orderTimeInterval);
      if (this.searchForm.orderTimeInterval && this.searchForm.orderTimeInterval.length > 0) {
        this.searchForm.orderTimeStart = this.searchForm.orderTimeInterval[0] || "";
        this.searchForm.orderTimeEnd = this.searchForm.orderTimeInterval[1] || "";
      }
      this.list = [];
      this.$store
        .dispatch("orderTo/index/selMjOrderListByParam", {
          ...this.searchForm,
          confirmStatus: this.searchForm.confirmStatus === "" ? undefined : this.searchForm.confirmStatus,
        })
        .then((res) => {
          console.log("res", res);
          res.data.list.forEach((item) => {
            if (item.vehicleList && item.vehicleList.length) {
              item.vehicleList.forEach((vItem) => {
                vItem.actualSendQuantity = vItem.pickupQuantity;
              });
            }
          });
          this.list = res.data.list || [];
          this.list.forEach((item) => {
            this.$set(item, "orderButtonEntityList", item.orderSellerButtonEntityList);
          });
          this.totalNum = parseInt(res.data.total);
          this.pageNum = parseInt(res.data.pageNum);
          this.loading = false;
        });
    },
    exportOrderList() {
      this.loading = true;
      console.log("this.searchForm.orderTimeInterval", this.searchForm.orderTimeInterval);
      if (this.searchForm.orderTimeInterval && this.searchForm.orderTimeInterval.length > 0) {
        this.searchForm.orderTimeStart = this.searchForm.orderTimeInterval[0] || "";
        this.searchForm.orderTimeEnd = this.searchForm.orderTimeInterval[1] || "";
      }
      this.$store.dispatch("orderTo/index/exportSellerOrderList", this.searchForm).then((res) => {
        console.log("res", res);
        this.loading = false;
        if (res.code !== 0 && res.code !== "0") {
          this.$message.warning(res.msg);
          return;
        }
        if (!res.data || !res.data.url) {
          this.$message.warning("导出数据为空");
          return;
        }
        window.open(res.data.url);
      });
    },
    resetOrderList() {
      this.searchForm.orderTimeStart = "";
      this.searchForm.orderTimeEnd = "";
      this.searchForm.orderId = "";
      this.searchForm.goodsName = "";
      this.searchForm.delivery = "";
      this.searchForm.orderVehicleStatus = "";
      this.searchForm.orderType = "";
      this.searchForm.nextSingleName = "";
      this.searchForm.receiverName = "";
      this.searchForm.orderTimeInterval = [];
    },
    orderCancel() {
      this.$prompt("请输入取消原因", "提示", {
        confirmButtonText: "提交",
        cancelButtonText: "取消",
      })
        .then(({ value }) => {
          if (value == "") {
            this.$message({
              type: "info",
              message: "请输入取消原因",
            });
            return;
          }
          this.$store
            .dispatch("orderTo/index/toCancelOrder", {
              orderId: this.order.orderId,
              cancelReason: value,
            })
            .then((res) => {
              if (res.success) {
                this.$message("取消成功");
                this.selOrderMjStatusByParam();
                this.selMjOrderListByParam();
              } else {
                this.$message({
                  type: "info",
                  message: res.errormsg,
                });
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "取消输入",
          });
        });
    },
    behalfPurchasePickup() {
      this.$confirm("你确定提货完成吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$store
          .dispatch("orderTo/index/editOrderBySeller", {
            orderId: this.order.orderId,
            orderStatus: 5,
          })
          .then((data) => {
            console.log("data: ", data);
            if (data.code != "0") {
              this.$message.error(data.msg);
              return;
            }
            console.log(data);
            this.selOrderMjStatusByParam();
            this.selMjOrderListByParam();
            this.$message("操作成功");
          });
      });
    },
    buttonSubmit(item, order) {
      console.log("seller buttonSubmit", item, order);
      this.order = order;
      this.orderGoodsList = order.orderGoodsBoList;
      switch (item.buttonCode) {
        case "to_confirm_self_delivery":
          this.$refs.order_seller_dialog.confirmSelfDelivery(item);
          return;
        case "to_confirm_receipt_confirmation":
          this.$refs.order_seller_dialog.selRefundOrderGoodsList();
          return;
        case "to_change_price":
          this.$refs.order_seller_dialog.editPriceOpen(item);
          return;
        case "to_cancel":
          this.orderCancel();
          return;
        case "to_deliver_goods":
          if (item.isAllowDeliver == 1) {
            if (order.sendSt == 3) {
              this.$router.push({
                path: "/seller/logistics",
                query: { orderId: item.orderId, type: 1 },
              });
              // this.$open(`${process.env.VUE_APP_APP}v/seller/logistics?orderId=${order.orderId}&type=1`, { title: "部分发货", target: 1 });
            } else {
              this.$refs.shippingOptionsRef.open(order.orderId);
            }

            // eslint-disable-next-line max-len
            //window.open(`${process.env.VUE_APP_APP}mj/order/manage/deliverOrderGoods?orderId=${item.orderId}`);
          } else {
            this.$message.error("该订单为付款人代下的订单，需要被代下单人填写上收货地址后，您才能发货，有疑问请联系付款人或平台客服。");
          }
          return;
        case "to_read_ping_jia":
          window.open(`${process.env.VUE_APP_APP}mj/order/manage/orderComment?orderId=${item.orderId}`);
          return;
        case "to_build_contract":
          this.$refs.contract_sign_dialog.getContractData(order.orderId, true, { ...item, buildContractVisible: true }, true);
          return;
        case "to_read_contract":
          this.$refs.contract_sign_dialog.viewContract(item);
          //window.open(`${process.env.VUE_APP_APP}contract/toEcontrantDetail?id=${item.contractId}&isBuyer=2`);
          return;
        case "to_sign_material":
          this.$refs.order_seller_dialog.editBalanceConfirmationOpen();
          return;
        case "to_read_material":
          window.open(`${process.env.VUE_APP_APP}contract/toMaterialConfirmationDetail?id=${item.orderId}&isBuyer=0`);
          return;
        case "to_create_sales_slip":
          window.open(`${item.salesSlipUrl}${item.orderId}`);
          return;
        case "to_read_sales_slip":
          window.open(`${item.salesSlipUrl}${item.orderId}`);
          return;
        case "to_read_refund":
          window.open(
            // eslint-disable-next-line max-len
            `${process.env.VUE_APP_APP}v/aftersales/detail/${item.refundOrderId}?orderId=${item.orderId}`
          );
          return;
        case "to_order_purchase":
          window.open(`${process.env.VUE_APP_APP}mj/order/manage/orderPurchase?orderId=${item.orderId}`);
          return;
        case "to_order_wu_liu":
          window.open(`${process.env.VUE_APP_APP}mj/order/manage/toLogisticsDetail?orderId=${item.orderId}`);
          return;
        // 修改发货信息
        case "to_modify_delivery_info":
          this.$refs.order_seller_dialog.editDeliveryInfoOpen(`${item.orderId}`);
          return;
        //签收单
        case "to_order_receipt":
          window.open(`${item.url}`);
          return;
        // 代采订单--提货完成
        case "to_behalf_purchase_pick_up":
          this.behalfPurchasePickup();
          return;
        // 预订单--终止提货
        case "to_finish_pick_up_yyd":
          this.$confirm('操作后，客户将无法基于此预订单继续提货<br />确认是否操作？', '确认', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
            dangerouslyUseHTMLString: true,
          }).then(async () => {
            const loading = this.$loading({
              lock: true,
              text: "加载中...",
            });
            const { code, msg } = await requestApi.post(`sctrading/order/mj/finished`, {
              orderId: this.order.orderId,
            });
            loading.close();
            if (code != '0') {
              this.$message.error(msg);
              return;
            }
            this.$message({
              type: 'success',
              message: '操作成功'
            });

            this.selMjOrderListByParam();
          }).catch(() => {});
          return;
        default:
          this.$message.error("无效按钮");
          return;
      }
    },
    loadOrder() {
      this.selOrderMjStatusByParam();
      this.selMjOrderListByParam();
    },
  },
};
